import React from 'react';

import StatementCard from '@components/ContactsStatement/StatementCard';
import { StatementContextProvider } from '@components/ContactsStatement/StatementContext';

const ContactDetailsStatement = ({
    contactID,
    contactType,
    contactSubType,
    onClose,
    range,
    period,
    persistFilters,
    filterOverrides,
}) => {
    const getDefaultStatementType = () => {
        if (contactType === 'Model') {
            return 'model';
        }
        switch (contactSubType) {
            case 1:
                return 'client';
            case 2:
                return 'agency';
            case 3:
                return 'service';
        }
    };

    return (
        <StatementContextProvider
            defaultStatementType={getDefaultStatementType()}
            defaultContactID={contactID}
            defaultContactType={getDefaultStatementType()}
            scope="statement"
            initialRange={range}
            initialPeriod={period}
            persistFilters={persistFilters}
            filterOverrides={filterOverrides}
        >
            <StatementCard onClose={onClose} />
        </StatementContextProvider>
    );
};

export default ContactDetailsStatement;
